import React from "react";
// Material imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
const useStyles = makeStyles(() => ({
  translationText: {
    marginLeft: "auto"
  }
}));
const TranslationText = () => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary",
    variant: "caption",
    className: classes.translationText
  }, t("Translated message"));
};
export default TranslationText;